/**
 * Inline mode: scan the host document for elements that opted into the inline
 * embed surface (`<div data-neutrix-agent="inline">`) and replace each with a
 * <neutrix-voice-agent> instance. The host element's own size & border-radius
 * are honored — we just stretch into it.
 */

export function mountInlineSurfaces(doc: Document): number {
  const slots = doc.querySelectorAll<HTMLElement>('[data-neutrix-agent="inline"]');
  let mounted = 0;
  for (const slot of slots) {
    if (slot.dataset['neutrixMounted'] === 'true') continue;
    const agent = doc.createElement('neutrix-voice-agent');
    agent.style.width = '100%';
    agent.style.height = '100%';
    agent.style.display = 'block';
    slot.appendChild(agent);
    slot.dataset['neutrixMounted'] = 'true';
    mounted += 1;
  }
  return mounted;
}
